import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import PageLayout from "../page-layout/PageLayout";

import { ROUTES } from "@/constants/routes";
import ClientForm from "@/features/clients/components/ClientForm/ClientForm";
import { AddClientProvider } from "@/lib/contexts/Client/AddClientProvider";
import { ClientProvider } from "@/lib/contexts/Client/ClientProvider";
import { useAuth } from "@/lib/hooks/useAuth";
import useToast from "@/lib/hooks/useToast";

const AddClientPage = () => {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const { tenantId } = useAuth();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(`/${ROUTES.clients}`);
  };

  const handleSuccess = (clientId: string) => {
    showToast(
      t("admin.client.clientAction.success", { action: "created" }),
      "success"
    );
    navigate(`/${ROUTES.clients}/${clientId}`);
  };

  return (
    <PageLayout>
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">
          {t("admin.client.addClient.title")}
        </h1>
        <p className="text-muted-foreground text-sm">
          {t("admin.client.addClient.description")}
        </p>
      </div>
      <div className="mt-6 w-full">
        <ClientProvider tenantId={tenantId}>
          <AddClientProvider tenantId={tenantId}>
            {(addClientContext) => (
              <ClientForm
                onCancel={handleCancel}
                onSubmitSuccess={handleSuccess}
                addClient={addClientContext}
              />
            )}
          </AddClientProvider>
        </ClientProvider>
      </div>
    </PageLayout>
  );
};

export default AddClientPage;
